import React from 'react';
import { TFunction } from 'i18next';

import { MenuItem } from '@mui/material';
import { Field } from 'formik';
import { Select } from 'formik-material-ui';
import { useCompanySizeChoices } from 'shared/hooks/api/demo';

interface CompanySizeFieldProps {
  currentLanguage: string;
  t: TFunction;
}

export default function CompanySizeField({
  currentLanguage,
  t,
}: CompanySizeFieldProps): JSX.Element {
  const { data: companySizeChoices, isLoading } =
    useCompanySizeChoices(currentLanguage);

  const companySizeChoicesOptions = React.useMemo(() => {
    if (isLoading || !companySizeChoices || companySizeChoices.length === 0) {
      return [
        <MenuItem key="loading" value="loading">
          Loading...
        </MenuItem>,
      ];
    }
    return companySizeChoices.map((companySize) => (
      <MenuItem key={companySize.code} value={companySize.code}>
        {companySize.display}
      </MenuItem>
    ));
  }, [companySizeChoices, isLoading]);

  return (
    <Field
      component={Select}
      name="additional_infos.company_size"
      label={t('Company Size')}
    >
      {companySizeChoicesOptions}
    </Field>
  );
}
